import "./base.js";

window.Sparkle ??= {};
window.Sparkle.PageBuilder ??= {};
window.Sparkle.PageBuilder.Modal ??= {};

Sparkle.PageBuilder.Modal.FormEditor = class FormEditor extends Sparkle.PageBuilder.Modal.Base {
  constructor(options) {
    super({
      class: "admin-modal form-builder-modal",
      ...options,
    });
    this.getOutput = this.getOutput.bind(this);
    if (options == null) {
      options = {};
    }
  }

  getOutput() {}
};
// No need to get output as the output will be handled externally in the form editor tool that instantiates the modal
Sparkle.PageBuilder.Modal.FormEditor.prototype.title = "Form Fields Editor";
